<script>
import CrudBase from '@components/cruds/CrudEditBase';
import FcmDate from "@components/diversos/FcmDate";
import FcmCityAutocomplete from "@components/diversos/FcmCityAutocomplete";
import FcmImage from "@components/image/FcmImage";
import FcmGallery from "@components/image/FcmGalery";
import {firestore, functions, Timestamp, FieldValue} from '@src/db';
import * as StringUtils from "@common/StringUtils";
import * as ObjectUtils from "@common/ObjectUtils";
import StorageUtils from "@common/StorageUtils";
import * as status from "@common/status";
import {authComputed} from "@store/helpers";
import firebase from 'firebase/app';

const ReportStatus = status.ReportStatus;

import {Chart, registerables} from 'chart.js';
Chart.register(...registerables);
import { Line as CLine } from 'vue-chartjs';

import {getDataGenres, getDataAges, getMarkers} from '@src/utils/charts';
import {encode} from 'js-base64';
import dayjs from '@common/dayjs';

export default {
  components: {FcmDate, FcmCityAutocomplete, FcmImage, FcmGallery, CLine},
  extends: CrudBase,
  props: {
    profileEdit: {
      type: Boolean,
    },
    isSuperAdmin: {
      type: Boolean,
    },
    reportId: {
      type: String,
      default: '',
    }
  },
  data(vm) {
    return {
      resource: 'users',
      confirmClose: true,
      StringUtils: StringUtils,
      ReportStatus: ReportStatus,
      defaultForm: {
        active: false,
      },
      newForm: {
        active: true,
      },

      changePassword: false,
      newPassword: '',
      showPassword: false,
      profileImage: null,
      // Dynamic email/username validation state, mirroring the mobile app's inline
      // availability feedback (debounced check-as-you-type, shown under each field).
      // Separate debounces per field so typing in one doesn't re-check the other.
      emailAvailabilityDebouncedFn: null,
      usernameAvailabilityDebouncedFn: null,
      usernameFormatError: '',
      usernameAvailability: null, // null | 'checking' | 'available' | 'unavailable'
      emailAvailability: null, // null | 'checking' | 'available' | 'unavailable'
      accessModel: [],
      userProviders: [],
      onEdit: false,
      events: [],
      eventSelected: null,
      analytics: {
        eventsGoOnSelectedMonthByDay: {},
        eventsSharedOnSelectedMonthByDay: {},
        eventsDisclosureOnSelectedMonthByDay: {},
        eventsLinksOnSelectedMonthByDay: {},
      },
      options: {
        responsive: true,
        scales: {
          yAxes: {
            // min: 0,
          }
        }
      },
      dateMonth: dayjs(),
      lastEventId: null,
      lastMonthKey: null,
      reportInfo: null,
      allBasicConnections: [],
      connections: [],
      connectionsTotal: 0,
      connectionsPage: 1,
      connectionsPageSize: 25,
      connectionsPageLoading: false,
      connectionsLoading: false,
      connectionsSearch: '',
      connectionsTableOptions: {
        sortBy: ['followAtSort'],
        sortDesc: [true],
        itemsPerPage: 25,
        mustSort: true,
        multiSort: false,
      },
      eventsTableOptions: {
        sortBy: ['eventDateSort'],
        sortDesc: [true],
        itemsPerPage: 10,
        mustSort: true,
        multiSort: false,
      },
      activeTab: 0,
    }
  },
  watch: {
    dateMonth(value) {
      this.loadEventAnalytics();
    },
    connectionsSearch() {
      this.connectionsPage = 1;
      this.loadConnectionsPage(1);
    },
    connectionsTableOptions: {
      deep: true,
      handler() {
        if (this.connectionsLoading) {
          return;
        }
        this.connectionsPage = 1;
        this.loadConnectionsPage(1);
      },
    },
  },
  computed:{
    ...authComputed,
    maxBirthDateISO() {
      return dayjs().subtract(18, 'years').format('YYYY-MM-DD');
    },
    filteredBasicConnections() {
      const q = (this.connectionsSearch || '').toLowerCase().trim();
      if (!q) return this.allBasicConnections;
      return this.allBasicConnections.filter(c =>
        (c.name || '').toLowerCase().includes(q) ||
        (c.username || '').toLowerCase().includes(q)
      );
    },
    sortedFilteredBasicConnections() {
      const sortBy = (this.connectionsTableOptions.sortBy || [])[0] || 'followAtSort';
      const sortDesc = Boolean((this.connectionsTableOptions.sortDesc || [])[0]);
      return this.sortTableItems(this.filteredBasicConnections, sortBy, sortDesc);
    },
    eventsTableItems() {
      return (this.events || []).map(event => {
        const eventLocationTxt = this.getLocalEvent(event);
        return {
          ...event,
          eventDateSort: this.getTableSortValue(event.eventDate),
          eventDateTxt: event.eventDate?.toDate ? dayjs(event.eventDate.toDate()).format('DD/MM/YYYY') : '',
          eventLocationTxt,
          eventLocationSort: this.getTableSortValue(eventLocationTxt),
        };
      });
    },
    connectionsHeaders() {
      return [
        { text: 'Conectado em', value: 'followAtSort', sortable: true },
        { text: 'Nome', value: 'name', sortable: true },
        { text: 'Username', value: 'username', sortable: true },
        { text: 'Email', value: 'email', sortable: true },
        { text: 'Data de nascimento', value: 'birthDateSort', sortable: true },
        { text: 'Gênero', value: 'gender', sortable: true },
      ];
    },
    eventsHeaders() {
      return [
        { text: '', value: 'eventImageUrl', sortable: false, width: 96 },
        { text: 'Data', value: 'eventDateSort', sortable: true, width: 140 },
        { text: 'Local', value: 'eventLocationSort', sortable: true },
        { text: 'Título', value: 'title', sortable: true },
        { text: 'Descrição', value: 'description', sortable: true },
      ];
    },
    haveFacebook: {
      get() {
        if (
            this.userProviders.find(function (el) {
              return el.providerId === 'facebook.com'
            })
        ) {
          return true
        }

        return false
      },
    },
    haveGoogle: {
      get() {
        return !!this.userProviders.find(function (el) {
          return el.providerId === 'google.com'
        })
      },
    },
    haveApple: {
      get() {
        return !!this.userProviders.find(function (el) {
          return el.providerId === 'apple.com'
        })
      },
    },
    havePassword: {
      get() {
        return !!this.userProviders.find(function (el) {
              return el.providerId === 'password'
            });
      },
    },
    isItSelf() {
      return this.currentUser?.id===this.form.id;
    },
    // Gender label of the details header (M, F or O), or the not informed text
    genderText() {
      const key = {M: 'male', F: 'female', O: 'other'}[this.form.gender];
      return key ? this.$t(`form.gender.${key}`) : this.$t('users.details.notInformed');
    },
    // City, state and country of the profile address, or the not informed text
    locationText() {
      const address = this.form.address || {};
      const parts = [address.city, address.state, address.country].filter((part) => part && String(part).trim());
      return parts.length ? parts.join(', ') : this.$t('users.details.notInformed');
    },
    // Based on iOS UserEntity.isMissingInfo(), plus gender (also a required registration field).
    isProfileIncomplete() {
      const form = this.form;
      const hasName = Boolean(form.name && String(form.name).trim());
      const hasUsername = Boolean(form.username && String(form.username).trim());
      const hasAddressCity = Boolean(form.address?.city && String(form.address.city).trim());
      const hasWellFormedProfilePictureUrl = this.isWellFormedUrl(form.profilePictureUrl);
      const hasBirthDateTimestamp = Boolean(form.birthDateTimestamp);
      const hasGender = Boolean(form.gender && String(form.gender).trim());
      const hasEmail = Boolean(form.email && String(form.email).trim());
      return !hasName || !hasUsername || !hasAddressCity || !hasWellFormedProfilePictureUrl || !hasBirthDateTimestamp || !hasGender || !hasEmail;
    },
    eventsGoByMonthSelectedGenres() {
      const data = this.analytics.eventsGoOnSelectedMonthByDay;
      const keys = [];
      let maxDay = parseInt(this.dateMonth.endOf('month').format('DD'));
      for (let i=1;i<=maxDay;i++) {
        keys.push({
          value: `${this.monthKey}-${i.toString().padStart(2, '00')}`,
          text: i.toString().padStart(2, '00'),
        });
      }
      return getDataGenres(data, keys);
    },
    eventsGoByMonthSelectedAges() {
      const data = this.analytics.eventsGoOnSelectedMonthByDay;
      const keys = [];
      let maxDay = parseInt(this.dateMonth.endOf('month').format('DD'));
      for (let i=1;i<=maxDay;i++) {
        keys.push({
          value: `${this.monthKey}-${i.toString().padStart(2, '00')}`,
          text: i.toString().padStart(2, '00'),
        });
      }
      return getDataAges(data, keys);
    },

    eventsSharedByMonthSelectedGenres() {
      const data = this.analytics.eventsSharedOnSelectedMonthByDay;
      const keys = [];
      let maxDay = parseInt(this.dateMonth.endOf('month').format('DD'));
      for (let i=1;i<=maxDay;i++) {
        keys.push({
          value: `${this.monthKey}-${i.toString().padStart(2, '00')}`,
          text: i.toString().padStart(2, '00'),
        });
      }
      return getDataGenres(data, keys);
    },
    eventsSharedByMonthSelectedAges() {
      const data = this.analytics.eventsSharedOnSelectedMonthByDay;
      const keys = [];
      let maxDay = parseInt(this.dateMonth.endOf('month').format('DD'));
      for (let i=1;i<=maxDay;i++) {
        keys.push({
          value: `${this.monthKey}-${i.toString().padStart(2, '00')}`,
          text: i.toString().padStart(2, '00'),
        });
      }
      return getDataAges(data, keys);
    },
    eventsDisclosureByMonthSelectedGenres() {
      const data = this.analytics.eventsDisclosureOnSelectedMonthByDay;
      const keys = [];
      let maxDay = parseInt(this.dateMonth.endOf('month').format('DD'));
      for (let i=1;i<=maxDay;i++) {
        keys.push({
          value: `${this.monthKey}-${i.toString().padStart(2, '00')}`,
          text: i.toString().padStart(2, '00'),
        });
      }
      return getDataGenres(data, keys);
    },
    eventsDisclosureByMonthSelectedAges() {
      const data = this.analytics.eventsDisclosureOnSelectedMonthByDay;
      const keys = [];
      let maxDay = parseInt(this.dateMonth.endOf('month').format('DD'));
      for (let i=1;i<=maxDay;i++) {
        keys.push({
          value: `${this.monthKey}-${i.toString().padStart(2, '00')}`,
          text: i.toString().padStart(2, '00'),
        });
      }
      return getDataAges(data, keys);
    },

    eventsLinksByMonthSelectedGenres() {
      const data = this.analytics.eventsLinksOnSelectedMonthByDay;
      const keys = [];
      let maxDay = parseInt(this.dateMonth.endOf('month').format('DD'));
      for (let i=1;i<=maxDay;i++) {
        keys.push({
          value: `${this.monthKey}-${i.toString().padStart(2, '00')}`,
          text: i.toString().padStart(2, '00'),
        });
      }
      return getDataGenres(data, keys);
    },
    eventsLinksByMonthSelectedAges() {
      const data = this.analytics.eventsLinksOnSelectedMonthByDay;
      console.log('data', data);

      const keys = [];
      let maxDay = parseInt(this.dateMonth.endOf('month').format('DD'));
      for (let i=1;i<=maxDay;i++) {
        keys.push({
          value: `${this.monthKey}-${i.toString().padStart(2, '00')}`,
          text: i.toString().padStart(2, '00'),
        });
      }
      return getDataAges(data, keys);
    },
  },
  updated() {
    /*
    for (const error in this.error || {}){
      if (this.form[error] && this.error[error]){ this.error[error] = false }
    } */
   // this.$refs.form.resetValidation()
  },
  async beforeMount() {
  },
  mounted: function() {
    // 700ms matches the debounce used by the mobile app's own username-availability check.
    this.emailAvailabilityDebouncedFn = _.debounce(async ()=>{
      await this.checkAvailability('email');
    }, 700);
    this.usernameAvailabilityDebouncedFn = _.debounce(async ()=>{
      await this.checkAvailability('username');
    }, 700);
  },
  methods: {
    async beforeInit() {
      this.changePassword= false;
      this.newPassword= '';
      this.showPassword= false;
      this.profileImage = null;
      this.usernameFormatError = '';
      this.usernameAvailability = null;
      this.emailAvailability = null;
      this.accessModel = [];
      this.onEdit = false;
      this.eventSelected = null;
      this.lastEventId = null;
      this.lastMonthKey = null;
      this.allBasicConnections = [];
      this.connections = [];
      this.connectionsTotal = 0;
      this.connectionsPage = 1;
      this.connectionsSearch = '';
      this.activeTab = 0;
      this.loadEventAnalytics();
    },
    async checkUserExist(result) {
      if(result.data.providerCode==='auth/user-not-found') {
        this.form.errorUserAuthNotFound = true;
        await firestore.collection(this.resource).doc(this.valueId).set({errorUserAuthNotFound: true},{merge: true});
      }
    },
    minAgeRule(value) {
      if(!value) {
        return true;
      }
      return dayjs().diff(dayjs(value), 'years')>=18 || this.$t('form.error.minAge');
    },
    // Mirrors the mobile app's client-side username rules (String+Extensions.swift /
    // SignupEmailAndPassword.swift): minimum 4 characters, and "voxtom"/"voxgo" forbidden
    // as a substring. Checked instantly, with no round-trip, before the debounced availability
    // check below.
    validateUsernameFormat(username) {
      const clean = (username || '').trim().toLowerCase();
      if (!clean) {
        return '';
      }
      if (clean.length < 4) {
        return this.$t('form.error.usernameMinLength');
      }
      if (clean.includes('voxtom') || clean.includes('voxgo')) {
        return this.$t('form.error.usernameInvalid');
      }
      return '';
    },
    onEmailInput(value) {
      const validFormat = Boolean(value && this.rules.email(value) === true);
      // Only blank the status when there's nothing (yet) to check — otherwise, keep showing
      // the last known status while typing continues, instead of flashing it to blank on
      // every keystroke until the next debounced check resolves.
      if (!validFormat) {
        this.emailAvailability = null;
      }
      if (validFormat) {
        this.emailAvailabilityDebouncedFn();
      }
    },
    onUsernameInput(value) {
      this.usernameFormatError = this.validateUsernameFormat(value);
      if (!value || this.usernameFormatError) {
        this.usernameAvailability = null;
      }
      if (!this.usernameFormatError && value) {
        this.usernameAvailabilityDebouncedFn();
      }
    },
    // The green "available" hint is only useful right after typing; clear it once the admin
    // moves on. Errors are left as-is since they keep the Concluir button disabled.
    onEmailBlur() {
      if (this.emailAvailability === 'available') {
        this.emailAvailability = null;
      }
    },
    onUsernameBlur() {
      if (this.usernameAvailability === 'available') {
        this.usernameAvailability = null;
      }
    },
    async checkAvailability(field) {
      const email = this.form.email;
      const username = this.form.username;
      const needCheckEmail = field === 'email' && Boolean(email && this.rules.email(email) === true);
      const needCheckUsername = field === 'username' && Boolean(username && !this.usernameFormatError);
      if (!needCheckEmail && !needCheckUsername) {
        return;
      }
      if (needCheckEmail) {
        this.emailAvailability = 'checking';
      }
      if (needCheckUsername) {
        this.usernameAvailability = 'checking';
      }
      try {
        const result = await functions.httpsCallable('users-checkUsernameAvailability')({
          email: needCheckEmail ? email : '',
          username: needCheckUsername ? username : '',
          // '' means "exclude no one" (isNew: checked against every account, including the
          // admin's own); editing an existing user excludes that user's own current values.
          excludeUserId: this.isNew ? '' : this.valueId,
        });
        if (result.data.errorCode !== status.apiErrorCode.OK) {
          // Surfaced instead of silently going blank, otherwise a broken/undeployed endpoint
          // just looks like the "checking" hint vanishing with no explanation.
          if (needCheckEmail) { this.emailAvailability = 'error'; }
          if (needCheckUsername) { this.usernameAvailability = 'error'; }
          return;
        }
        if (needCheckEmail) {
          this.emailAvailability = result.data.data.emailAvailable ? 'available' : 'unavailable';
        }
        if (needCheckUsername) {
          this.usernameAvailability = result.data.data.available ? 'available' : 'unavailable';
        }
      } catch (error) {
        console.error('checkAvailability', error);
        if (needCheckEmail) { this.emailAvailability = 'error'; }
        if (needCheckUsername) { this.usernameAvailability = 'error'; }
      }
    },
    // Resizes (only shrinks, aspect-preserving, when maxWidth/maxHeight given) a data URL and
    // re-encodes it as PNG without painting any background first — same technique as
    // FcmImageEditor's _updatePreviewPng — so a transparent source stays transparent.
    resizePngPreservingAlpha(dataUrl, maxWidth, maxHeight) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          let w = img.width;
          let h = img.height;
          if (maxWidth && w > maxWidth) {
            h = Math.floor((h * maxWidth) / w);
            w = maxWidth;
          }
          if (maxHeight && h > maxHeight) {
            w = Math.floor((w * maxHeight) / h);
            h = maxHeight;
          }
          const canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          canvas.getContext('2d').drawImage(img, 0, 0, w, h);
          resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = reject;
        img.src = dataUrl;
      });
    },
    async validateEmailUsernameAvailability(form) {
      const result = await functions.httpsCallable('users-checkUsernameAvailability')({
        email: form.email,
        username: form.username,
        excludeUserId: this.isNew ? '' : this.valueId,
      });
      if(result.data.errorCode!==status.apiErrorCode.OK) {
        this.$showError({title: this.$t('apiErrorCode.'+result.data.errorCode)});
        return false;
      }
      if(!result.data.data.emailAvailable) {
        this.$showError({title: this.$t('apiErrorCode.emailAlreadyExists')});
        return false;
      }
      if(!result.data.data.available) {
        this.$showError({title: this.$t('apiErrorCode.usernameAlreadyExists')});
        return false;
      }
      return true;
    },
    async beforeSaveAccount(form) {
      //  let fakeMail = 'ua_'+form.email.replace('@', '_')+'@adminusers.'+appConfig.emailKey;
      let fakeMail = form.email;
      let result = null;
      if(this.isNew) {
        if(!fakeMail) {
          this.$showError({title: this.$t('form.error.emailRequired')})
          return false;
        }
        if(!this.newPassword) {
          this.$showError({title: this.$t('form.error.passwordRequired')})
          return false;
        }
        // birthDateISO/gender/address are sent here (instead of relying only on the merge
        // below) so the user doc is already complete on this first write — two rapid writes
        // in a row race the usersOnWrite Typesense sync trigger and can leave the search
        // index stuck with the incomplete first version (see usersOnWrite in users.f.ts).
        result = await functions.httpsCallable('auth-registerUser')({
          email: fakeMail,
          password: this.newPassword,
          name: form.name || '',
          username: form.username || '',
          birthDateISO: form.birthDateISO || '',
          gender: form.gender || '',
          address: form.address || null,
          // The password here is set by the admin, not chosen by the user — same reasoning
          // as the bulk-import flow: force a change on first login.
          mustChangePassword: true,
        });
        if(result.data.errorCode!==status.apiErrorCode.OK) {
          console.log('Error', result.data.errorCode, result.data.providerCode);
          throw this.JwGetError(this.$t('form.error.createUser')+': '+ (result.data.providerCode?this.$t('login.providerCode.'+result.data.providerCode):this.$t('apiErrorCode.'+result.data.errorCode)));
        }
        // registerUser generates its own Firebase Auth uid and already writes the initial
        // Firestore doc under it; repoint valueId so the merge below lands on that same doc
        // instead of the client-generated id, which would otherwise leave an orphaned doc.
        this.valueId = result.data.data.userId;
        return true;
      }
      else {
        if(this.changePassword && this.isSuperAdmin) {
          if(!this.newPassword) {
            this.$showError({title: this.$t('form.error.passwordRequired')})
            return false;
          }
          result = await functions.httpsCallable('auth-changePassword')({id: this.valueId, workspace:'CLIENT', password: this.newPassword});
          if(result.data.errorCode!==status.apiErrorCode.OK) {
            await this.checkUserExist(result);
            console.log('Error', result.data.errorCode, result.data.providerCode);
            throw this.JwGetError(this.$t('form.error.changePassword')+': '+ (result.data.providerCode?this.$t('login.providerCode.'+result.data.providerCode):this.$t('apiErrorCode.'+result.data.errorCode)));
          }
        }
        if(fakeMail && this.original.email!==fakeMail && this.isSuperAdmin) {
          if(!fakeMail) {
            this.$showError({title: this.$t('form.error.emailRequired')})
            return false;
          }
          result = await functions.httpsCallable('auth-changeEmail')({id: this.valueId, workspace:'CLIENT', email: fakeMail});
          if(result.data.errorCode!==status.apiErrorCode.OK) {
            console.log('Error', result.data.errorCode, result.data.providerCode);
            await this.checkUserExist(result);
            throw this.JwGetError(this.$t('form.error.changeEmail')+': '+ (result.data.providerCode?this.$t('login.providerCode.'+result.data.providerCode):this.$t('apiErrorCode.'+result.data.errorCode)));
          }
          //form.fakeMail = fakeMail;
        }
        return true;
      }
    },
    async beforeSave(form) {
      if (this.$refs.form && !this.$refs.form.validate()) {
        console.log('form inválido nos requires')
        this.tryingToUpdate = false;
        return;
      }
      // FcmCityAutocomplete's :rules aren't reliably enforced by VForm.validate() (it's a
      // wrapper around VAutocomplete bound via :value/@input rather than v-model), so the
      // required check is duplicated here as a hard guard.
      if (!form.address || !form.address.city) {
        this.$showError({title: this.$t('form.error.required')});
        this.tryingToUpdate = false;
        return;
      }
      if(!(await this.validateEmailUsernameAvailability(form))) {
        this.tryingToUpdate = false;
        return;
      }
      if(typeof form.birthDateISO==='string') {
        let date = dayjs(form.birthDateISO);
        if(date.isValid()) {
          // Store 00:00:00 in the local timezone, matching what the mobile apps write.
          date = date.startOf('day');
          // birthDateTimestamp is the field the mobile apps read to compute age;
          // birthDate is kept for backward compatibility with older records/screens.
          form.birthDate = Timestamp.fromDate(date.toDate());
          form.birthDateTimestamp = Timestamp.fromDate(date.toDate());
        }
        else {
          form.birthDateISO = null;
        }
      }
      else {
        form.birthDate = null;
        form.birthDateTimestamp = null;
      }
      form = {
        ...form,
        active: Boolean(form.active),
        nameLowerCase: StringUtils.deburr(form.name),
        phone: (form.phone || '').trim(),
        cpf: (form.cpf || '').replace(/[^\d]/g, ''),
        email: (form.email||'').toLowerCase().trim(),
      }
      delete form.search;

      let result = await this.beforeSaveAccount(form);
      if(!result) {
        console.log('Skipped');
        await this.close();
        return false;
      }

      try {
        // Photo isn't required (per product decision) — if none was picked, profilePictureUrl/
        // hdProfilePictureUrl are simply left empty in Firestore. The default placeholder is a
        // display-only fallback (see the view-mode template below), never persisted.
        const sourceDataUrl = this.profileImage?._tmp?.dataUrl || null;

        if(sourceDataUrl) {
          this.uploadProgress = 0;
          this.tryingToUpload = true;
          // valueId may have just changed (new user created above); wait for it to settle
          // before using it to build the Storage paths below.
          await this.$nextTick();
          // Same dual-size approach as the mobile app's uploadProfileImage (a resized SD copy
          // for profilePictureUrl, an unresized HD copy for hdProfilePictureUrl, same file
          // naming), but PNG instead of JPEG — matching how VoxSpotEdit's logo upload keeps a
          // transparent background. ImageUtils.compactImageFromDataUrl always paints a white
          // background before compressing (fine for JPEG, but flattens transparent PNGs), so
          // resizing is done here instead, the same way FcmImageEditor's own PNG path
          // (_updatePreviewPng) does it: draw onto a canvas with no fill, keeping alpha.
          const [sdDataUrl, hdDataUrl] = await Promise.all([
            this.resizePngPreservingAlpha(sourceDataUrl, 300, 300),
            this.resizePngPreservingAlpha(sourceDataUrl, 0, 0),
          ]);
          const [sdUrl, hdUrl] = await Promise.all([
            StorageUtils.uploadString(
              `users/${this.valueId}/${this.valueId}_profilePicture.png`,
              sdDataUrl, (p)=>{ this.uploadProgress = p; }, undefined, 'data_url', 'image/png'
            ),
            StorageUtils.uploadString(
              `users/${this.valueId}/${this.valueId}_profilePicture_HD.png`,
              hdDataUrl, ()=>{}, undefined, 'data_url', 'image/png'
            ),
          ]);
          form.profilePictureUrl = sdUrl;
          form.hdProfilePictureUrl = hdUrl;
        }
        else if(!this.profileImage?.url) {
          form.profilePictureUrl = null;
          form.hdProfilePictureUrl = null;
        }
      } catch(error) {
        console.error('Erro ao fazer upload da foto de perfil', error);
        this.$showError({title: this.$t('form.error.uploadError')});
      }
      this.tryingToUpload = false;

      return form;
    },
    async beforeLoad(form) {
      this.reportInfo = null;
      form.phone = form.phone || '';
      this.profileImage = form.profilePictureUrl ? {url: form.profilePictureUrl} : null;
      if(this.isNew) {
        // Default to the most permissive valid value (exactly 18 years old today) so the
        // picker doesn't open decades away from a sensible date the admin has to change anyway.
        form.birthDateISO = form.birthDateISO || this.maxBirthDateISO;
      }

      console.log('firebase.auth().currentUser?.id', firebase.auth().currentUser?.uid);
      console.log('form.id', form.id);

      if (this.currentUser?.id===form.id) {
        console.log('equals');
        this.userProviders = firebase.auth().currentUser.providerData;
      }
      else {
        console.log('Diff');
      }
      if(!form.birthDateISO && (form.birthDate || form.birthDateTimestamp)) {
        let m = dayjs((form.birthDate || form.birthDateTimestamp).toDate());
        if(m.isValid()) {
          form.birthDateISO = m.format('YYYY-MM-DD');
        }
      }
      this.$bind('events', firestore.collection('events').where('ownerId', '==', this.valueId)
          .orderBy('eventDate', 'desc'));

      this.connectionsLoading = true;
      const connectionsSnap = await firebase.database().ref('userFollowers/' + this.valueId).get();
      const connectionsData = connectionsSnap.val() || {};
      const basicConnections = Object.entries(connectionsData)
        .map(([uid, c]) => ({ uid: (c.user && (c.user.id || c.user.key)) || uid, ...(c.user || {}), followAt: c.followAt || null }))
        .filter((c) => c && c.name && c.username && c.active !== false);

      this.allBasicConnections = basicConnections;
      this.connectionsTotal = basicConnections.length;
      this.connectionsPage = 1;
      this.connectionsLoading = false;
      await this.loadConnectionsPage(1);

      if (this.reportId) {
        const reportInfo = {
          report: {...(await firestore.collection('reportsUsers').doc(this.reportId).get()).data(), id: this.reportId},
        };
        if (reportInfo.report?.reportById) {
          reportInfo.userBy = {...(await firestore.collection('users').doc(reportInfo.report.reportById).get()).data(), id: reportInfo.report.reportById};
        }

        this.reportInfo = reportInfo;
      }

      return form;
    },
    async loadConnectionsPage(page) {
      this.connectionsPageLoading = true;
      const start = (page - 1) * this.connectionsPageSize;
      const pageItems = this.sortedFilteredBasicConnections.slice(start, start + this.connectionsPageSize);
      if (pageItems.length > 0) {
        const profileSnaps = await Promise.all(
          pageItems.map(c => firestore.collection('users').doc(c.uid).get())
        );
        this.connections = pageItems.map((c, i) => {
          const profile = profileSnaps[i].exists ? profileSnaps[i].data() : {};
          const birthDateISO = profile.birthDateISO || (profile.birthDate ? dayjs(profile.birthDate.toDate()).format('YYYY-MM-DD') : '');
          return {
            ...c,
            active: profile.active !== false,
            email: profile.email || '',
            birthDateISO,
            birthDateSort: birthDateISO,
            birthDateTxt: birthDateISO ? dayjs(birthDateISO).format('DD/MM/YYYY') : '',
            gender: profile.gender || '',
            followAtSort: this.getTableSortValue(c.followAt),
            followAtTxt: c.followAt ? dayjs(c.followAt).format('DD/MM/YYYY') : '',
          };
        }).filter(c => c.active);
      } else {
        this.connections = [];
      }
      this.connectionsPageLoading = false;
    },
    async removeProvider(provider) {
      if (provider.providerId === 'password') {
        this.$showError({ title: this.$t('form.error.deleteProviderEmail') })
        return
      }

      if (!this.havePassword) {
        this.$showError({
          title: this.$t('form.error.deleteProviderEmailNeed'),
        })
        return
      }

      try {
        await firebase.auth().currentUser.unlink(provider.providerId)
        this.$showSuccess()
      } catch (error) {
        this.$showError({ title: this.$t('form.error.deleteProviderEmail') })
      }
      if (firebase.auth().currentUser) {
        this.userProviders = firebase.auth().currentUser.providerData
      }
    },

    async addProviderSocial(provider) {
      let providerObj = null
      switch (provider) {
        case 'facebook.com':
          providerObj = new firebase.auth.FacebookAuthProvider()
          break
        case 'google.com':
          providerObj = new firebase.auth.GoogleAuthProvider()
          break
        case 'apple.com':
          providerObj = new firebase.auth.OAuthProvider('apple.com')
          break
        default:
          return Promise.reject(new Error('Unknown provider'))
      }

      try {
        await firebase.auth().currentUser.linkWithPopup(providerObj);
        this.$showSuccess();
      } catch (error) {
        this.$showError({
          title: this.$t('login.error.loginTitle'),
          text: this.$t('login.providerCode.' + error.code),
        })
      }
      if (firebase.auth().currentUser) {
        this.userProviders = firebase.auth().currentUser.providerData
      }
    },
    async showEvent(event) {
      this.eventSelected = event;
      await this.$nextTick();
      document.getElementById('eventDetais').scrollIntoView({
        behavior: 'smooth'
      });
      console.log(this.eventSelected?.id);
      this.loadEventAnalytics();
    },
    getLocalEvent(event) {
      let local = event.eventPlace?.country?event.eventPlace.country+' | ':'';
      local += event.eventPlace?.city?event.eventPlace.city+' ':'';
      local += event.eventPlace?.state?'('+event.eventPlace.state+')':'';
      return local;
    },
    async loadEventAnalytics() {
      this.analytics.eventsGoOnSelectedMonthByDay = null;
      this.analytics.eventsSharedOnSelectedMonthByDay = null;
      this.analytics.eventsDisclosureOnSelectedMonthByDay = null;
      this.analytics.eventsLinksOnSelectedMonthByDay = null;
      if (!this.eventSelected) {
        this.lastEventId = null;
        return;
      }
      this.monthKey = this.dateMonth.format('YYYY-MM');
      if (this.lastMonthKey===this.monthKey && this.lastEventId===this.eventSelected?.id) {
        return;
      }
      this.lastMonthKey = this.monthKey;
      this.lastEventId = this.eventSelected?.id;
      const startMonthDay = this.dateMonth.startOf('month').format('YYYY-MM-DD');
      const endMonthDay = this.dateMonth.clone().add(+1, 'month').startOf('month').format('YYYY-MM-DD');

      const eventsGoOnSelectedMonthByDayP = firebase.database()
          .ref(`/Analytics/EventsGo/Daily/${this.lastEventId}`)
          .orderByKey()
          .startAt(startMonthDay)
          .endAt(endMonthDay)
          .get();
      const eventsSharedOnSelectedMonthByDayP = firebase.database()
          .ref(`/Analytics/EventsShared/Daily/${this.lastEventId}`)
          .orderByKey()
          .startAt(startMonthDay)
          .endAt(endMonthDay)
          .get();
      const eventsDisclosureOnSelectedMonthByDayP = firebase.database()
          .ref(`/Analytics/EventsDisclosure/Daily/${this.lastEventId}`)
          .orderByKey()
          .startAt(startMonthDay)
          .endAt(endMonthDay)
          .get();

      const eventsLinksOnSelectedMonthByDayP = [];
      for (const link of this.eventSelected?.lstLinks || []) {
        eventsLinksOnSelectedMonthByDayP.push(firebase.database()
            .ref(`/Analytics/EventsLinkVisited/Daily/${this.lastEventId}/${link.id}`)
            .orderByKey()
            .startAt(startMonthDay)
            .endAt(endMonthDay)
            .get())
      }

      this.analytics.eventsGoOnSelectedMonthByDay = (await eventsGoOnSelectedMonthByDayP).val();
      this.analytics.eventsSharedOnSelectedMonthByDay = (await eventsSharedOnSelectedMonthByDayP).val();
      this.analytics.eventsDisclosureOnSelectedMonthByDay = (await eventsDisclosureOnSelectedMonthByDayP).val();

      const tmp = (await Promise.all(eventsLinksOnSelectedMonthByDayP)).map(a=>a.val());
      this.analytics.eventsLinksOnSelectedMonthByDay = ObjectUtils.mergeSumObj(tmp);
    },
    async deleteUser() {
      if(!await this.$showConfirm({title: this.$t('form.alert.deleteUser')})) {
        return;
      }
      await firestore.collection(this.resource).doc(this.valueId).set({
        active: false
      }, {merge: true});
      this.$showSuccess();
    },
    async reportAccepted() {
      if (!this.reportId) {
        this.$showError();
        return;
      }
      await firestore.collection('reportsUsers').doc(this.reportId).set({
        status: ReportStatus.ACCEPTED,
        acceptedBy: this.currentUser.id,
        acceptedAt: FieldValue.serverTimestamp(),
        meta: {
          updatedAt: FieldValue.serverTimestamp(),
          updatedBy: this.currentUser.id,
        }
      }, {merge: true});
      this.reportInfo.report.status = ReportStatus.ACCEPTED;
      this.$showSuccess();
    },
    async reportRejected() {
      if (!this.reportId) {
        this.$showError();
        return;
      }
      await firestore.collection('reportsUsers').doc(this.reportId).set({
        status: ReportStatus.REJECTED,
        rejectedBy: this.currentUser.id,
        rejectedAt: FieldValue.serverTimestamp(),
        meta: {
          updatedAt: FieldValue.serverTimestamp(),
          updatedBy: this.currentUser.id,
        }
      }, {merge: true});
      this.reportInfo.report.status = ReportStatus.REJECTED;
      this.$showSuccess();
    },
    sendNotification() {
      const b64 = encode(JSON.stringify({
        refId: this.valueId,
        type: status.NotificationManualType.USER,
        title: this.form.name || '',
        image: {
          url: this.form.profilePictureUrl || null,
          mime: 'image/jpg'
        },
      }));
      this.$router.push({name: 'admin/notifications', params: {id: this.$newId()}, query: {info: b64}});
    },
    // profilePictureUrl/hdProfilePictureUrl can be a non-empty but dead link (deleted Storage
    // object, etc.), which the `||` fallback chain in the template can't catch since it only
    // triggers on empty/null. This catches the actual browser load failure instead.
    onProfileImageError(event) {
      event.target.onerror = null; // avoid a loop if the fallback image itself fails to load
      event.target.src = require('@assets/images/placeholder/defaultProfilePicture.svg');
    },
    isWellFormedUrl(urlString) {
      if (!urlString) return false;
      try {
        const url = new URL(urlString);
        return Boolean(url.protocol) && Boolean(url.hostname);
      } catch {
        return false;
      }
    },
    async setPassword() {
      const newPassword = await this.$showPrompt({input: 'password', title: 'Nova senha'});
      if (!newPassword) {
        return;
      }
      const result = await functions.httpsCallable('auth-changePassword')({id: this.valueId, workspace:'CLIENT', password: newPassword});
      if(result.data.errorCode!==status.apiErrorCode.OK) {
        console.log('Error', result.data.errorCode, result.data.providerCode, result.data);
        this.$showError({
          title: 'Erro ao definir senha',
          text: (result.data.providerCode?this.$t('login.providerCode.'+result.data.providerCode):this.$t('apiErrorCode.'+result.data.errorCode)),
        });
      }
      else {
        this.$showSuccess();
      }
    },
    getTableSortValue(value) {
      if (value == null || value === '') {
        return '';
      }
      if (typeof value === 'number') {
        return value;
      }
      if (typeof value === 'boolean') {
        return value ? 1 : 0;
      }
      if (value?.toMillis) {
        return value.toMillis();
      }
      if (value?.toDate) {
        const date = value.toDate();
        return date ? date.getTime() : '';
      }
      if (value instanceof Date) {
        return value.getTime();
      }
      if (typeof value === 'string') {
        const parsed = Date.parse(value);
        if (!Number.isNaN(parsed) && /[-/:T]/.test(value)) {
          return parsed;
        }
        return _.deburr(value).toLowerCase();
      }
      return _.deburr(String(value)).toLowerCase();
    },
    sortTableItems(items, sortBy, sortDesc) {
      const normalizedSortBy = Array.isArray(sortBy) ? sortBy[0] : sortBy;
      const normalizedSortDesc = Array.isArray(sortDesc) ? sortDesc[0] : sortDesc;
      if (!normalizedSortBy) {
        return (items || []).slice();
      }
      const desc = Boolean(normalizedSortDesc);
      const compareValues = (a, b) => {
        if (a === b) {
          return 0;
        }
        if (a == null || a === '') {
          return 1;
        }
        if (b == null || b === '') {
          return -1;
        }
        if (typeof a === 'string' && typeof b === 'string') {
          return a.localeCompare(b, 'pt', {numeric: true, sensitivity: 'base'});
        }
        return a < b ? -1 : 1;
      };
      return (items || []).slice().sort((itemA, itemB) => {
        const aValue = this.getTableSortValue(ObjectUtils.getObjectValueByPath(itemA, normalizedSortBy));
        const bValue = this.getTableSortValue(ObjectUtils.getObjectValueByPath(itemB, normalizedSortBy));
        const compare = compareValues(aValue, bValue);
        return desc ? compare * -1 : compare;
      });
    },
  }
}
</script>

<template>
  <div>
    <div v-show="isLoading" >
      <VProgressCircular indeterminate color="primary"></VProgressCircular>
    </div>
    <div v-if="!isLoading">
      <div class="reportBy" v-if="reportInfo">
        Reportado por: {{reportInfo.userBy?.name}} ({{reportInfo.userBy?.username}}) <br>
        Motivo: {{reportInfo.report?.reason}} <br>
        Status: {{$t('ReportStatus.'+reportInfo.report?.status)}} <br>
        Reportado: {{dayjs(reportInfo.meta?.createdAt?.toDate()).format('DD/MM/YYYY HH:mm')}} <br>
        <div v-if="reportInfo.report?.status===ReportStatus.REPORTED">
          <VBtn
              max-width="300px"
              color="success"
              class="mr-4 mt-3"
              @click="reportAccepted"
          >
            Marcar como aceito
          </VBtn>
          <VBtn
              max-width="300px"
              color="success"
              class="mr-4 mt-3"
              @click="reportRejected"
          >
            Marcar como recusado
          </VBtn>
        </div>

        <hr class="mt-3" />
      </div>
      <div v-if="onEdit || isNew">
        <VBtn
            v-if="isNew"
            text
            small
            color="success"
            class="mb-2"
            @click="$emit('bulkImport')"
        >
          <VIcon left small>mdi-file-import-outline</VIcon>
          {{$t('users.bulkImport.linkFromCreateForm')}}
        </VBtn>
        <VForm ref="form">
          <VContainer>
            <VRow>
              <VCol cols="12">
                <p class="caption mb-1">{{$t('form.profilePicture')}}</p>
                <FcmGallery ref="fcmGallery">
                  <FcmImage
                      ref="fcmImage"
                      v-model="profileImage"
                      :folder="'users/'+valueId"
                      path-file="profile"
                      :quality-argument="0.85"
                      mime-type-image="image/png"
                      :aspect-ratio="1"
                      view-max-width="200px"
                      view-max-height="200px"
                      :max-width="512"
                      :max-height="512"
                      :default-image="require('@assets/images/placeholder/defaultProfilePicture.svg')"
                      :show-default-when-empty="!isNew"
                      open-editor-after-add
                  ></FcmImage>
                </FcmGallery>
              </VCol>
            </VRow>
            <VRow>
              <VCol cols="12" md="6">
                <VTextField
                    v-model="form.email"
                    :rules="[rules.email, rules.required]"
                    :label="$t('form.email')"
                    @input="onEmailInput"
                    @blur="onEmailBlur"
                ></VTextField>
                <p v-if="emailAvailability==='checking'" class="caption grey--text">{{$t('form.checking')}}</p>
                <p v-else-if="emailAvailability==='unavailable'" class="caption red--text">{{$t('apiErrorCode.emailAlreadyExists')}}</p>
                <p v-else-if="emailAvailability==='available'" class="caption green--text">{{$t('form.available')}}</p>
                <p v-else-if="emailAvailability==='error'" class="caption orange--text">{{$t('form.error.checkAvailabilityError')}}</p>
              </VCol>
              <VCol cols="12" md="6">
                <VTextField
                    v-model="form.username"
                    :rules="[rules.required]"
                    :label="$t('form.username')"
                    @input="onUsernameInput"
                    @blur="onUsernameBlur"
                ></VTextField>
                <p v-if="usernameFormatError" class="caption red--text">{{usernameFormatError}}</p>
                <p v-else-if="usernameAvailability==='checking'" class="caption grey--text">{{$t('form.checking')}}</p>
                <p v-else-if="usernameAvailability==='unavailable'" class="caption red--text">{{$t('form.usernameNotAvailable')}}</p>
                <p v-else-if="usernameAvailability==='available'" class="caption green--text">{{$t('form.available')}}</p>
                <p v-else-if="usernameAvailability==='error'" class="caption orange--text">{{$t('form.error.checkAvailabilityError')}}</p>
              </VCol>
            </VRow>
            <VRow>
              <VCol cols="12" md="6">
                <VTextField
                    v-model="form.name"
                    :rules="[rules.required]"
                    :label="$t('form.name')"
                ></VTextField>
              </VCol>
              <VCol cols="12" md="6">
                <FcmDate
                    v-model="form.birthDateISO"
                    :label="$t('form.birthDate')"
                    :read-only="false"
                    :rules="[rules.required, minAgeRule]"
                    :max="isNew ? maxBirthDateISO : undefined"
                    type="iso"
                ></FcmDate>
              </VCol>
            </VRow>
            <VRow>
              <VCol cols="12" md="6">
                <VSelect
                    v-model="form.gender"
                    :items="[
                          {text: $t('form.gender.male'), value: 'M'},
                          {text: $t('form.gender.female'), value: 'F'},
                          {text: $t('form.gender.other'), value: 'O'},
                        ]"
                    :label="$t('form.genderText')"
                    :placeholder="$t('form.select')"
                    :rules="[rules.required]"
                ></VSelect>
              </VCol>
              <VCol cols="12" md="6">
                <FcmCityAutocomplete
                    v-model="form.address"
                    :rules="[rules.required]"
                ></FcmCityAutocomplete>
              </VCol>
            </VRow>
            <div v-if="isItSelf">
              <div>{{$t('login.providers')}}</div>
              <table class="tableAll">
                <tr v-for="item of userProviders">
                  <td>{{ item.providerId || '' }}</td>
                  <td>{{ item.email || '' }}</td>
                  <td>{{ item.uid || '' }}</td>
                  <td><VBtn @click="removeProvider(item)"><VIcon>mdi-delete</VIcon></VBtn></td>
                </tr>
              </table>
              <br>
              <VBtn
                  v-if="!haveFacebook"
                  class="mr-2"
                  :disabled="tryingToUpdate"
                  @click="addProviderSocial('facebook.com')"
              >
                <VIcon v-if="tryingToUpdate" name="sync" spin />
                <span v-else>
                  {{$t('login.addFacebook')}}
                </span>
              </VBtn>
              <br v-if="!haveGoogle" />
              <VBtn
                  v-if="!haveGoogle"
                  class="mr-2"
                  :disabled="tryingToUpdate"
                  @click="addProviderSocial('google.com')"
              >
                <VIcon v-if="tryingToUpdate" name="sync" spin />
                <span v-else>
                  {{$t('login.addGoogle')}}
                </span>
              </VBtn>
              <br v-if="!haveGoogle" />
              <VBtn
                  v-if="!haveApple"
                  class="mr-2"
                  :disabled="tryingToUpdate"
                  @click="addProviderSocial('apple.com')"
              >
                <VIcon v-if="tryingToUpdate" name="sync" spin />
                <span v-else>
                  {{$t('login.addApple')}}
                </span>
              </VBtn>
            </div>

            <VRow
                v-if="(isNew || (!isNew && isSuperAdmin) || (!isNew && currentUser.id === valueId))"
            >
              <VCol v-if="!isNew && (isSuperAdmin || currentUser.id === valueId)" cols="12" sm="2" md="2">
                <VSwitch
                    v-model="changePassword"
                    :label="$t('form.changePassword')"
                    :value="true"
                    hide-details
                    inset
                    dense
                ></VSwitch>
              </VCol>
              <VCol v-show="changePassword || isNew" cols="12" sm="6" md="5">
                <VTextField
                    v-model="newPassword"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    :label="$t('form.password')"
                    autocomplete="no"
                    :rules="changePassword || isNew?[rules.required]:[]"
                    @click:append="showPassword = !showPassword"
                ></VTextField>
              </VCol>
            </VRow>
            <VRow v-if="hasError">
              <VCol cols="12" sm="12" md="12">
                <p>
                  {{$t('form.error.update')}}<br>{{hasError.message? hasError.message:''}}
                </p>
              </VCol>
            </VRow>
            <VRow>
              <VCol cols="12" sm="12" md="12">
                <VProgressLinear v-if="typeof tryingToUpload!=='undefined' && typeof uploadProgress!=='undefined' && tryingToUpload" :value="uploadProgress"></VProgressLinear>
              </VCol>
            </VRow>

            <VRow class="'mt-4'">
              <VCol>
                <VBtn
                    max-width="300px"
                    :disabled="!valid || tryingToUpdate || emailAvailability==='unavailable' || emailAvailability==='checking' || usernameAvailability==='unavailable' || usernameAvailability==='checking'"
                    color="success"
                    class="mr-4 mt-3"
                    @click="conclude"
                >
                  {{$t('form.conclude')}}
                </VBtn>
                <VBtn
                    :disabled="tryingToUpdate"
                    color="warning"
                    class="mt-3"
                    @click="close(null, true)"
                >
                  {{$t('form.close')}}
                </VBtn>
              </VCol>
            </VRow>
          </VContainer>
        </VForm>
      </div>
      <div v-else>
        <div class="cover" v-if="form.coverPictureUrl">
          <img :src="form.coverPictureUrl" />
        </div>
        <div class="headerShow">
          <div class="profile">
            <img
                :src="form.profilePictureUrl || form.hdProfilePictureUrl || require('@assets/images/placeholder/defaultProfilePicture.svg')"
                @error="onProfileImageError"
            />
          </div>
          <div class="profileBody">
            <h3>{{form.name}} ({{form.username}})</h3>
            <h3>{{form.email}} {{form.phone}}</h3>
            <h3 v-if="form.birthDateISO">{{$t('users.details.birthDate')}} {{dayjs(form.birthDateISO).format('DD/MM/YYYY')}}</h3>
            <h3>{{$t('users.details.gender')}} {{genderText}}</h3>
            <h3>{{$t('users.details.location')}} {{locationText}}</h3>
            <h3 v-if="form.meta?.createdAt?.toDate">{{$t('users.details.createdAt')}} {{dayjs(form.meta.createdAt.toDate()).format('DD/MM/YYYY HH:mm')}}</h3>
          </div>
          <br>
          <div class="d-flex align-end">
            <div class="d-flex flex-column align-start mr-4 mt-3">
              <VChip v-if="isProfileIncomplete" color="error" text-color="white" class="mb-1" style="font-weight: 500; font-size: 14px; height: 32px; text-transform: uppercase; letter-spacing: 0.0892857143em;">
                Perfil incompleto
              </VChip>
              <VBtn
                  v-if="form.active"
                  max-width="500px"
                  color="success"
                  @click="sendNotification"
              >
                Enviar notificação vinculando esse usuário
              </VBtn>
            </div>
            <VBtn
                v-if="form.active"
                max-width="300px"
                color="success"
                class="mr-4 mt-3"
                @click="deleteUser"
            >
              Deletar usuário
            </VBtn>
            <VBtn
                max-width="300px"
                color="success"
                class="mr-4 mt-3"
                @click="onEdit = true"
            >
              Editar
            </VBtn>
            <VBtn
                max-width="300px"
                color="success"
                class="mr-4 mt-3"
                @click="setPassword"
            >
              Definir nova senha
            </VBtn>
          </div>
        </div>
        <hr>
        <VTabs v-model="activeTab" class="mt-2">
          <VTab>Eventos</VTab>
          <VTab>Conexões</VTab>
        </VTabs>
        <VTabsItems v-model="activeTab">
          <VTabItem>
            <div class="events pa-4">
              <h3 class="mb-3">
                Eventos ({{ events.length }})
              </h3>
              <VDataTable
                :headers="eventsHeaders"
                :items="eventsTableItems"
                :options.sync="eventsTableOptions"
                class="jwDataTableNoPointer"
                hide-default-footer
                disable-pagination
                @click:row="showEvent"
              >
                <template #item.eventImageUrl="{ item }">
                  <img class="eventThumb" :src="item.eventImageUrl" :alt="item.title">
                </template>
                <template #item.eventDateSort="{ item }">
                  {{ item.eventDateTxt }}
                </template>
                <template #item.eventLocationSort="{ item }">
                  {{ item.eventLocationTxt }}
                </template>
                <template #item.description="{ item }">
                  <span class="eventDescription">{{ item.description }}</span>
                </template>
              </VDataTable>
            </div>
          </VTabItem>
          <VTabItem>
            <div class="connections pa-4">
              <h3 class="mb-3">
                Conexões
                ({{ connectionsSearch ? filteredBasicConnections.length + ' de ' + connectionsTotal : connectionsTotal }})
              </h3>
              <VProgressCircular v-if="connectionsLoading" indeterminate color="primary" />
              <template v-else>
                <div v-if="connectionsTotal === 0" class="text--secondary">Nenhuma conexão encontrada.</div>
                <template v-else>
                  <VTextField
                    v-model="connectionsSearch"
                    placeholder="Pesquisar por nome ou username..."
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    dense
                    outlined
                    hide-details
                    class="mb-3"
                  />
                  <VProgressLinear v-if="connectionsPageLoading" indeterminate color="primary" class="mb-2" />
                  <div v-if="!connectionsPageLoading && filteredBasicConnections.length === 0" class="text--secondary">
                    Nenhuma conexão encontrada para "{{ connectionsSearch }}".
                  </div>
                  <template v-else>
                    <VDataTable
                      :headers="connectionsHeaders"
                      :items="connectionsPageLoading ? [] : connections"
                      :options.sync="connectionsTableOptions"
                      class="jwDataTableNoPointer"
                      hide-default-footer
                      disable-pagination
                    >
                      <template v-slot:item.followAtSort="{ item }">
                        {{ item.followAtTxt }}
                      </template>
                      <template v-slot:item.birthDateSort="{ item }">
                        {{ item.birthDateTxt }}
                      </template>
                    </VDataTable>
                    <div class="d-flex justify-center mt-3" v-if="filteredBasicConnections.length > connectionsPageSize">
                      <VPagination
                        v-model="connectionsPage"
                        :length="Math.ceil(filteredBasicConnections.length / connectionsPageSize)"
                        :total-visible="7"
                        @input="loadConnectionsPage(connectionsPage)"
                      />
                    </div>
                  </template>
                </template>
              </template>
            </div>
          </VTabItem>
        </VTabsItems>
        <hr>
        <div id="eventDetais" v-if="eventSelected" >
          <h3 class="mb-4">Detalhes do evento</h3>
          <div class="eventSelectedHeader">
            <div class="containerEvent row">
              <div class="col-12 col-lg-10 offset-lg-1">
                <header class="voxtom-splash-logo preview-voxtom-splash-logo">
                  <div class="menu_user">
                    <div class="imagem_capa">
                      <img :src="eventSelected.eventImageUrl">
                    </div>
                    <div class="user_info_studio">
                      <div class="artist_attr_studio">
                        <div class="local">{{getLocalEvent(eventSelected)}} {{eventSelected.eventDate?.toDate?dayjs(eventSelected.eventDate?.toDate()).format('DD/MM/YYYY'):''}}</div>
                        <div class="name">
                          {{eventSelected.title}}
                        </div>
                        <div class="sobremim">{{eventSelected.description}}</div>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div>
            <div class="mt-13">
              <h2>Estatísticas do evento no mês selecionado</h2>
              <div>
                <div class="dateMonth">
                  <FcmDate
                      v-model="dateMonth"
                      type="dayjs"
                      pick-month
                      start-on-month
                      format="MM/YYYY"
                      mask="##/####"
                  />
                </div>
              </div>
            </div>
            <div class="charts">
              <h3>
                Participação de usuários em eventos
              </h3>
              <CLine v-if="eventsGoByMonthSelectedGenres" class="chart" :data="eventsGoByMonthSelectedGenres" :options="options" />
              <CLine v-if="eventsGoByMonthSelectedAges" class="chart" :data="eventsGoByMonthSelectedAges" :options="options" />
            </div>
            <div class="charts">
              <h3>
                Divulgações de eventos
              </h3>
              <CLine v-if="eventsDisclosureByMonthSelectedGenres" class="chart" :data="eventsDisclosureByMonthSelectedGenres" :options="options" />
              <CLine v-if="eventsDisclosureByMonthSelectedAges" class="chart" :data="eventsDisclosureByMonthSelectedAges" :options="options" />
            </div>
            <div class="charts">
              <h3>
                Compartilhamentos de eventos
              </h3>
              <CLine v-if="eventsSharedByMonthSelectedGenres" class="chart" :data="eventsSharedByMonthSelectedGenres" :options="options" />
              <CLine v-if="eventsSharedByMonthSelectedAges" class="chart" :data="eventsSharedByMonthSelectedAges" :options="options" />
            </div>
            <div class="charts">
              <h3>
                Cliques em links de eventos
              </h3>
              <CLine v-if="eventsLinksByMonthSelectedGenres" class="chart" :data="eventsLinksByMonthSelectedGenres" :options="options" />
              <CLine v-if="eventsLinksByMonthSelectedAges" class="chart" :data="eventsLinksByMonthSelectedAges" :options="options" />
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
// @import '@design';


.dateMonth {
  max-width: 180px;
}

.reportBy {
  margin-bottom: 20px;
  padding-bottom: 0px;
}

.charts {
  .chart {
    // background-color: #1E1E1E;
    max-height: 550px;
  }
}
.eventSelectedHeader {
  display: flex;
  justify-content: center;
}

.events {
  margin-top: 40px;
  margin-left: 20px;
  margin-right: 20px;
}

.eventThumb {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 12px;
}

.eventDescription {
  display: inline-block;
  max-width: 420px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cover {
  width: calc(100% - 40px);
  max-width: 1100px;
  margin: 0 auto 16px;
  overflow: hidden;
  border-radius: 12px;
}

.cover img {
  display: block;
  width: 100%;
  height: clamp(90px, 8vw, 120px);
  object-fit: cover;
  object-position: center top;
}

.headerShow {
  display: flex;
  justify-content: space-between;
  margin-left: 20px;
  margin-right: 20px;
  align-items: center;
  flex-wrap: wrap;

  .profile img {
    max-height: 130px;
  }

  .profileBody {
    flex: 2;
    padding-left: 10px;
  }
  padding-bottom: 20px;
}

.tableAll {
  border-collapse: collapse;
  border: 1px solid var(--v-listItemBorder-base);
  th, td {
    border: 1px solid var(--v-listItemBorder-base);
    padding: 10px 25px 10px 10px;
  }
}



.preview-logo {
    max-height: 45px;
}

.oficial_logo {
    margin-right: 15px;
}


.containerEvent {
    cursor: pointer;
    max-width: 400px;
}

.audience_content {
    margin-top: 8px;
    display: flex;
    align-content: space-around;
    font-family: Roboto;
}
    .audience_box {
        flex: 1;
        margin: 10px;
        display: flex;
        padding: 10px;
        background-color: #1C1C1C;
        align-content: space-around;
        min-width: 100px;
        border-radius: 9px;
    }
        .audience_icon {
            width: 85px;
            height: 85px;
        }
        .audience_data {
            flex: 1;
            display: flex;
            align-content: space-around;
            flex-direction: column;
        }
            .audience_number {
                flex: 1;
                font-size: 28px;
                color: #B1B1B1;
                font-weight: 600;
            }
            .audience_text {
                flex: 1;
                font-size: 15px;
                color: #23FF00;
                font-weight: 600;
            }
.info_content {
    margin-top: 5px;
    font-family: Roboto;

}
    .info_item {
        display: flex;
        padding: 10px;
        border-bottom: solid 1px #404040;
    }
        .info_icon {
            width: 48px;
            height: 48px;
        }
        .info_text {
            flex: 1;
            align-self: center;
            /* color: #f2f2f2; */
            color: #ffffff;
            font-size: 17px;
            text-align: justify;
            padding-left: 25px;
        }
        .info_icon_right {
            width: 16px;
            height: 26px;
            align-self: center;
        }

.download_content {
    margin-top: 15px;
    display: flex;
    background-color: #FFFFFF;
    border-radius: 50px;
    padding: 8px;
    padding-right: 20px;
}
    .download_chamada {
        flex: 1;
        font-family: Roboto;
        font-size: 32px;
        color: #0e0e0e;
        align-self: center;
    }
    .download_logo {
        /*width: 48px;*/
        height: 41px;
        margin-right: 17px;
        align-content: space-around;
        align-self: center;
    }

    .download_logo img {
        max-width: 100%;
        max-height: 100%;
        height: auto;
    }

    .download_android {

    }
    .download_ios {

    }

.imagem_capa {
    img {
      min-height: 200px;
      max-height: 550px;
      max-width: 400px;
    }
}


</style>
